import { Controller } from 'stimulus'

import {
  getTextContentBetween,
  createAnchorElementFromSelection,
  getBuilderResourcesForLinkPicker,
} from '../utilities'
import { camelCase } from 'lodash-es'

export default class extends Controller {
  static values = {
    currentLandingPageId: String,
  }

  openLinkPicker = (event) => {
    let {
      detail: {
        args: { editorController, onlyText },
      },
    } = event

    this.editorController = editorController

    const options = {
      callback: this.toggleLink,
      resourcesToExclude: [],
      contextObjectType: '',
      hideDisplayAsButton: true,
      extraResources: getBuilderResourcesForLinkPicker(),
      // Lets the URL field offer this editor's own merge tags ({{event_location_url}},
      // {{participant_url}}, …) as link targets, the way the classic editor's dialog already
      // does. Without it the picker opens with no Personalizations group at all.
      groupedResources: editorController.hasLinkPickerGroupedResourcesValue
        ? editorController.linkPickerGroupedResourcesValue
        : [],
      currentLandingPageId: this.currentLandingPageIdValue
        ? this.currentLandingPageIdValue
        : null,
    }

    const text = getTextContentBetween(editorController.editor)
    const anchorElement = createAnchorElementFromSelection(
      editorController.editor
    )

    if (text) {
      options['selectedText'] = text
      onlyText = true
    }

    options['onlyText'] = onlyText

    if (anchorElement) {
      anchorElement.innerHTML = text
      options['selectedAnchor'] = anchorElement
    }

    const uriDialog =
      window.parent?.Simplero?.InternalUriDialog ||
      window.top?.Simplero?.InternalUriDialog

    uriDialog?.open(options)
  }

  toggleLink = (attrs) => {
    const entries = Object.keys(attrs).map((key) => {
      const newKey = camelCase(key)

      return { [newKey]: attrs[key] }
    })
    attrs = Object.assign({}, ...entries)

    // Add data-trackable attribute if the link should not be tracked
    if (attrs.trackable === false) {
      attrs['dataTrackable'] = 'false'
    }

    let action = 'setLink'

    if (attrs.href === '' || !attrs.href) {
      action = 'unsetLink'
    }

    this.editorController.toolbarActions[action](attrs)
  }
}
